import _ from 'lodash'
import moment from 'moment'

const timeToDuration = (start, end) => {
  if (!start) {
    start = 0
  }
  let timeMill = end - moment(end).startOf('day').valueOf()
  start = moment(start).startOf('day')
  end = moment(end).startOf('day')
  let years = end.diff(start, 'years', true)
  let months = end.diff(start, 'months', true)
  let weeks = end.diff(start, 'weeks', true)
  let days = end.diff(start, 'days', true)
  let mills = end.diff(start)
  let zero = moment(0).startOf('day')
  let result = 0
  if (_.isInteger(years)) {
    result = zero.add(years, 'years')
  } else if (_.isInteger(months)) {
    result = zero.add(months, 'months')
  } else if (_.isInteger(weeks)) {
    result = zero.add(weeks, 'weeks')
  } else if (_.isInteger(days)) {
    result = zero.add(days, 'days')
  } else {
    result = zero.add(mills, 'milliseconds')
  }
  result = result.valueOf() + timeMill
  return result
}

const durationToTime = (start, duration) => {
  let result = 0
  if (!start) {
    start = 0
  }
  let timeMill = duration - moment(duration).startOf('day').valueOf()
  let zero = moment(0).startOf('day')
  duration = moment(duration).startOf('day')
  let years = duration.diff(zero, 'years', true)
  let months = duration.diff(zero, 'months', true)
  let weeks = duration.diff(zero, 'weeks', true)
  let days = duration.diff(zero, 'days', true)
  let mills = duration.diff(zero)
  start = moment(start).startOf('day')
  if (_.isInteger(years)) {
    result = start.add(years, 'years')
  } else if (_.isInteger(months)) {
    result = start.add(months, 'months')
  } else if (_.isInteger(weeks)) {
    result = start.add(weeks, 'weeks')
  } else if (_.isInteger(days)) {
    result = start.add(days, 'days')
  } else {
    result = start.add(mills, 'milliseconds')
  }
  result = result + timeMill
  return result
}

const dateList = (start, end, group) => {
  if (!group) {
    group = 'day'
  }
  if (!end) {
    end = moment().valueOf()
  }
  if (!start || start >= end) {
    switch (group) {
      case 'day':
        start = moment(end).subtract(6, 'd').startOf('day').valueOf()
        break
      case 'month':
        start = moment(end).subtract(1, 'y').startOf('month').valueOf()
        break
      case 'year':
        start = moment(end).subtract(2, 'y').startOf('year').valueOf()
        break
    }
  }
  let step = moment(end).diff(start, group + 's') + 1
  let list = []
  for (let i = 0; i < step; i++) {
    let _date = moment(start).clone().add(i, group + 's')
    let _year = _date.year()
    let _month = _date.month() + 1
    let _day = _date.date()
    let _name = ''
    switch (group) {
      case 'day':
        _name = _year + '-' + _month + '-' + _day
        break
      case 'month':
        _name = _year + '-' + _month
        break
      case 'year':
        _name = _year
        break
    }
    list.push(_name)
  }
  return list
}

export default {
  timeToDuration,
  durationToTime,
  dateList
}
